import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { CityInputDto, CityService, CityUpdateDto, StoreService } from 'src/generated_client';

@Component({
  selector: 'app-add-city',
  templateUrl: './add-city.component.html',
  styleUrls: ['./add-city.component.css']
})
export class AddCityComponent implements OnInit {
  id: any;
  isEdit: boolean = false;
  title: string = "";
  cityInput: CityInputDto = {} as CityInputDto;
  cityUpdate: CityUpdateDto = {} as CityUpdateDto;
  nameFormat = "^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1])[a-zA-ZÀ-ÿ\u00f1\u00d1]+$";
  disabled: boolean = false;

  options = [
    { value: true, viewValue: 'Activa' },
    { value: false, viewValue: 'Desactivada' },
  ];

  addCityForm: FormGroup = this.fb.group({
    name: ['', Validators.compose([Validators.pattern(this.nameFormat), Validators.required])],
    status: ['', Validators.required],
  })

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public cityService: CityService,
    public storeService: StoreService,
    public router: Router,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get("id")
    if (this.id != null) {
      this.isEdit = true;
      this.cityService.apiCityGetByIdGet(this.id).subscribe(x => {
        this.addCityForm.controls['name'].setValue(x.dsName);
        this.addCityForm.controls['status'].setValue(x.isActive);
        if (x.isActive) {
          this.storeService.apiStoreGetAllStoresGet().subscribe(s => {
            let result = s.some(store => store.dsCityName == x.dsName && store.isEnabled);
            if (result) {
              this.addCityForm.controls['status'].disable()
            }
          });
        }
      });
    }
    this.changeTitle();
  }

  changeTitle() {
    if (this.isEdit) {
      this.title = "EDITAR CIUDAD";
    } else {
      this.title = "AGREGAR NUEVA CIUDAD";
    }
  }

  saveChanges(form: any) {
    if (this.isEdit) {
      this.cityUpdate = {
        cdCity: Number(this.id),
        dsName: form.name,
        isActive: form.status
      }
      this.cityService.apiCityEditCityPut(this.cityUpdate).subscribe(response => {
        this.router.navigate(['city-management']);
        this.snackBar.openSnackBar('Los cambios fueron guardados','Aceptar')
      }, (err) => {
        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
      });
    } else {
      this.cityInput = {
        dsName: form.name,
        isActive: form.status
      }
      this.cityService.apiCityPostNewCityPost(this.cityInput).subscribe(response => {
        this.router.navigate(['city-management']);
        this.snackBar.openSnackBar('Los cambios fueron guardados','Aceptar')
      }, (err) => {
        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
      });
    }
  }

}
